import React, { useState, useEffect } from 'react';
import { Table, Button, Modal, Switch, Tag, Descriptions, Divider } from 'antd';
import api from '../utils/api';
import { useMenuPermission } from '../hooks/useMenuPermission';

const paramCols = [
  { title: '参数名', dataIndex: 'name', width: 160 },
  { title: '说明', dataIndex: 'desc' },
  { title: '必填', dataIndex: 'required', width: 60, align: 'center', render: v => <Tag color={v==='是'?'red':'default'}>{v}</Tag> },
  { title: '示例', dataIndex: 'example', width: 200 }
];

function ApiOpenEndpoints() {
  const { canEdit } = useMenuPermission();
  const [data, setData] = useState([]);
  const [detailVisible, setDetailVisible] = useState(false);
  const [detailItem, setDetailItem] = useState(null);
  const [myKey, setMyKey] = useState(null);

  const load = async () => {
    try { const r = await api.get('/api-open/configs'); if (r.code === 200) setData(r.data); } catch (e) {}
  };
  const loadMyKey = async () => {
    try { const r = await api.get('/api-open/my-key'); if (r.code === 200 && r.data) setMyKey(r.data); } catch (e) {}
  };
  useEffect(() => { load(); loadMyKey(); }, []);

  const cols = [
    { title: 'ID', dataIndex: 'id', width: 50 },
    { title: '名称', dataIndex: 'name', width: 140 },
    { title: '路由', dataIndex: 'route', width: 260 },
    { title: '方法', dataIndex: 'method', width: 70, render: v => <Tag color="blue">{v}</Tag> },
    { title: '启用', dataIndex: 'enabled', width: 80,
      render: (v, r) => canEdit ? <Switch checked={v===1} onChange={async () => { await api.put(`/api-open/configs/${r.id}`, { enabled: v?0:1 }); load(); }} /> : <Tag color={v?'green':'red'}>{v?'启用':'禁用'}</Tag> },
    { title: '操作', width: 100,
      render: (_, r) => <Button type="link" size="small" onClick={() => { setDetailItem(r); setDetailVisible(true); }}>查看详情</Button> }
  ];

  return (
    <div>
      <h3 style={{ margin: '0 0 16px 0' }}>端点管理</h3>
      {myKey && (
        <div style={{ marginBottom: 16, padding: 12, background: '#fff7e6', borderRadius: 6, border: '1px solid #ffd591' }}>
          <strong>你的API Key：</strong><code style={{ fontSize: 13 }}>{myKey.api_key}</code>
          <span style={{ marginLeft: 12, color: '#999' }}>（{myKey.name}）</span>
        </div>
      )}
      <Table rowKey="id" columns={cols} dataSource={data} pagination={false} size="small" />
      <Modal title="接口详情" open={detailVisible} onCancel={() => setDetailVisible(false)} footer={null} width={750}>
        {detailItem && (
          <div>
            <Descriptions column={1} size="small" bordered style={{ marginBottom: 16 }}>
              <Descriptions.Item label="接口名称">{detailItem.name}</Descriptions.Item>
              <Descriptions.Item label="路由"><Tag color="blue">{detailItem.method}</Tag> {detailItem.route}</Descriptions.Item>
              <Descriptions.Item label="接口描述">{detailItem.description || '-'}</Descriptions.Item>
            </Descriptions>
            <Divider orientation="left" plain>所需参数</Divider>
            {Array.isArray(detailItem.params) ? (
              <Table columns={paramCols} dataSource={detailItem.params.map((p, i) => ({ ...p, key: i }))} pagination={false} size="small" bordered />
            ) : (
              <pre style={{ background:'#f5f5f5', padding:16, borderRadius:8, whiteSpace:'pre-wrap', fontSize:13, margin:0 }}>{detailItem.params || '-'}</pre>
            )}
            <Divider orientation="left" plain>调用示例</Divider>
            <pre style={{ background: '#1e1e1e', color: '#d4d4d4', padding: 16, borderRadius: 8, whiteSpace: 'pre-wrap', fontSize: 12, lineHeight: 1.6, maxHeight: 400, overflow: 'auto', margin: 0 }}>{detailItem.example || '-'}</pre>
          </div>
        )}
      </Modal>
    </div>
  );
}

export default ApiOpenEndpoints;
